// extracted by mini-css-extract-plugin
export var centerText = "_6h-8";
export var container = "_6h-0";
export var doughnutContainer = "_6h-7";
export var legend = "_6h-a";
export var legendItemColorDisplay = "_6h-b";
export var legendItemLabel = "_6h-d";
export var legendItemValue = "_6h-c";
export var lg = "_6h-5";
export var maxWidth = "_6h-9";
export var md = "_6h-4";
export var responsive = "_6h-6";
export var sm = "_6h-3";
export var xs = "_6h-2";
export var xxs = "_6h-1";